module.exports = __webpack_public_path__ + "img/a1.176d9daf.png";